<template>
  <b-container fluid="xxl">
    <b-row class="align-items-center">
      <b-col cols="12" md="8">
        <h3>{{ $t('NAV_LINK_TEXT_ADMIN_PAGE_TRANSFER') }}</h3>
        <p class="text-muted small mb-0">Exportiert alle aktiven Page-Gruppen, Page-Tags und Produkte (nur Promotionpages) als JSON an einen Webhook.</p>
      </b-col>
      <b-col cols="12" md="4" class="text-md-right mt-3 mt-md-0">
        <b-button :disabled="loading" variant="cta" @click="startExport">
          <span v-if="!loading">Jetzt übertragen</span>
          <span v-else>Übertragung läuft…</span>
        </b-button>
      </b-col>
    </b-row>

    <b-card class="mt-4">
      <div class="d-flex align-items-center mb-3">
        <b-progress :value="progressValue" :max="5" height="1.25rem" class="flex-grow-1 mr-3"></b-progress>
        <div class="text-nowrap"><strong>{{ progressText }}</strong></div>
      </div>

      <div v-if="result" class="mt-3">
        <b-alert :variant="result.ok ? 'success' : 'danger'" show>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fa', result.ok ? 'check' : 'triangle-exclamation']" class="mr-2"/>
            <div>
              <div class="mb-1">{{ result.ok ? 'Fertig: Webhook bestätigt.' : 'Abgeschlossen mit Fehlern' }}</div>
              <div class="small text-muted">HTTP {{ result.http_code }} • Gruppen: {{ result.counts?.page_groups || 0 }} • Tags: {{ result.counts?.page_tags || 0 }} • Produkte: {{ result.counts?.products || 0 }}</div>
            </div>
          </div>
        </b-alert>

        <div class="mt-3">
          <h6 class="mb-2">Details</h6>
          <pre class="small bg-light p-3 border rounded" style="white-space: pre-wrap; word-break: break-word;">{{ resultString }}</pre>
        </div>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'areaAdminPageTransfer',
  data() {
    return {
      loading: false,
      progress: { step: 0, message: '' },
      result: null,
      showDetails: true,
    }
  },
  computed: {
    progressValue() {
      return Number(this.progress?.step || 0)
    },
    progressText() {
      return this.progress?.message || 'Bereit'
    },
    resultString() {
      return this.result ? JSON.stringify(this.result, null, 2) : ''
    }
  },
  methods: {
    async startExport() {
      this.loading = true
      this.result = null
      this.progress = { step: 0, message: 'Starte Export…' }
      try {
        const payload = {
          type: 'page_transfer_export',
          cookie: this.$store.getters.getToken,
        }
        const response = await axios.post(process.env.VUE_APP_API, payload, { withCredentials: true })
        const data = response && response.data ? response.data : null
        if (data && data.progress) {
          this.progress = data.progress
        }
        this.result = data
      } catch (e) {
        this.result = { ok: false, error: e?.message || String(e) }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
